/**
 * Created by fuzhengsong on 2017/9/7.
 */
import Vue from 'vue';

Vue.directive('holder', {
  inserted: function (el, binding) {
    //判断是否支持placeholder属性 如果不支持 执行
    if (el && !("placeholder" in document.createElement("input"))) {
      var funPlaceholder = function (element, binding) {
        let createNewElement = function (nod, text) {
          let ele = document.createElement('div');
          let node = document.createTextNode(text);
          ele.appendChild(node);
          if (/large/.test(nod.parentNode.getAttribute('class'))) {
          }
          if (/small/.test(nod.parentNode.getAttribute('class'))) {

          } else {
            ele.style.cssText = "display:block;position:absolute;color:#bfcbd9;";
          }
          ele.setAttribute('class','in-placeholder');
          return ele;
        };
        var placeholder = '';
        placeholder = element.getAttribute('placeholder');
        let ele = createNewElement(element, placeholder);
        element.addEventListener('focus', function () {
          // 如果值和placeholder值相等 说明没有更改或者输入 置为空
          ele.style.display = 'none';
          if (this.value === placeholder) {
            this.value = "";
          }
          this.style.color = '';
          document.addEventListener('selectionchange', selectionChg);
        });
        element.addEventListener('blur', function () {
          if (this.value === '') {
            ele.style.display = 'block';
          }
          document.removeEventListener('selectionchange', selectionChg);
        });
        //样式初始化
        if (element.value === "") {
          element.parentNode.appendChild(ele);
          ele.addEventListener('click', function () {
            this.style.display = 'none';
            element.focus();
          })
        }
      };
      let element;
      // find input元素
      var findEle = function (el) {
        if (el.tagName.toLowerCase() !== 'input' || el.tagName.toLowerCase() !== 'textarea') {
          for (var i = 0; i < el.childNodes.length; i++) {
            if (el.childNodes[i].tagName && (el.childNodes[i].tagName.toLowerCase() === 'input' || el.childNodes[i].tagName.toLowerCase() === 'textarea')) {
              return el.childNodes[i];
            }
          }
        }
      };
      element = findEle(el);
      // 对获取焦点的元素监听selectionchange事件，修复ie9 delete不触发的bug
      var selectionChg = function () {
        var el = document.activeElement;
        if (el.tagName === 'TEXTAREA' || (el.tagName === 'INPUT')) {
          var ev = document.createEvent('CustomEvent');
          ev.initCustomEvent('input', true, true, {});
          setTimeout(function () {
            el.dispatchEvent(ev);
          }, 20);
        }
      };
      funPlaceholder(element, binding);
    }
  }
});



// WEBPACK FOOTER //
// ./src/directive/placeholder.js